// extracted by mini-css-extract-plugin
module.exports = {"sfdcModalContainer":"salesforce-add-email_sfdcModalContainer_jk_","emptyIcon":"salesforce-add-email_emptyIcon_1eE"};